import { usePage } from '@inertiajs/react';

/**
 * Translation helper hook
 * Usage: const __ = useTrans();
 * Then: __('Dashboard')
 */
export function useTrans() {
    const { translations } = usePage().props;
    
    return (key, replacements = {}) => {
        let translation = translations?.[key] || key;
        
        // If translation is an object, return the key instead
        if (typeof translation === 'object' && translation !== null) {
            console.warn(`Translation key "${key}" returned an object instead of a string`);
            return key;
        }
        
        // Handle replacements like :name, :count, etc.
        Object.keys(replacements).forEach(placeholder => {
            translation = translation.replace(
                new RegExp(`:${placeholder}`, 'g'),
                replacements[placeholder]
            );
        });
        
        return translation;
    };
}

/**
 * Simple translation function
 * Usage: __('Dashboard')
 */
export function __(key, replacements = {}) {
    // Get translations from window object (set by Inertia)
    const translations = window.__translations || {};

    let translation = translations[key] || key;
    
    // If translation is an object, return the key instead
    if (typeof translation === 'object' && translation !== null) {
        console.warn(`Translation key "${key}" returned an object instead of a string`);
        return key;
    }
    
    // Handle replacements
    Object.keys(replacements).forEach(placeholder => {
        translation = translation.replace(
            new RegExp(`:${placeholder}`, 'g'),
            replacements[placeholder]
        );
    });
    
    return translation;
}

/**
 * Translation component for simple usage
 * Usage: <Trans>Dashboard</Trans>
 */
export function Trans({ children, replacements = {} }) {
    const __ = useTrans();
    return __(children, replacements);
}
